import { createUseStyles } from "react-jss";
import { BORDERS, SPACING } from "../../../constants/styleGuide";

/**
 * styles used in the component.
 */
export const CreateBudgetIntakeStyles = createUseStyles({
  leftContent: {
    paddingRight: "0px",
  },
  rightContent: {
    padding: SPACING.s16,
    backgroundColor: "#fff",
    marginBottom: "16px",
  },
  contentSpacing8: {
    paddingTop: SPACING.s8,
    paddingBottom: SPACING.s8,
  },
  contentSpacing16: {
    paddingTop: SPACING.s16,
    width: "100%",
  },
  contentSpacing24: {
    paddingTop: SPACING.s24,
    width: "100%",
  },
  contentSpacing48: {
    paddingTop: SPACING.s48,
  },
  columnLeftPadding: {
    paddingLeft: SPACING.s10,
  },
  columnRightPadding: {
    paddingRight: SPACING.s10,
  },
  columnSpacing: {
    padding: "0px 16px 24px 16px",
    backgroundColor: "#fff",
  },
  subTitle: {
    fontSize: "24px !important",
    lineHeight: "1.4",
    marginTop: "0",
    marginBottom: "6px",
  },
  flexGrid: {
    display: "flex",
    flexDirection: "column",
  },
  container: {
    background: "#f1f1f2",
    width: "100%",
  },
  subType: {
    fontSize: "14px",
    lineHeight: "1.43",
    marginBottom: "10px",
  },
  budgetTypeTotal: {
    marginTop: "18px",
  },
  overviewTableHeader: {
    display: "contents",
  },
  overviewTableHeaderRow: {
    padding: "16px",
    fontSize: "12px",
    lineHeight: "1.33",
    color: "#2e2f32",
    fontWeight: "bold",
    border: BORDERS.BLUE_GREY,
  },
  overviewHeaderRowRight: {
    textAlign: "right",
    padding: "16px",
    fontSize: "12px",
    lineHeight: "1.33",
    color: "#2e2f32",
    fontWeight: "bold",
    border: BORDERS.BLUE_GREY,
  },
  overviewTableBody: {
    display: "contents",
  },
  overviewTableBodyRow: {
    padding: "16px",
    fontSize: "12px",
    lineHeight: "1.33",
    color: "#2e2f32",
    border: BORDERS.BLUE_GREY,
  },
  overviewTableBodyRowEdit: {
    paddingLeft: "16px",
    paddingRight: "16px",
    paddingBottom: "8px",
    fontSize: "12px",
    lineHeight: "1.33",
    color: "#2e2f32",
    border: BORDERS.BLUE_GREY,
  },
  overviewTableBodyRowRemove: {
    border: BORDERS.BLUE_GREY,
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  overviewBodyRowRight: {
    textAlign: "right",
    padding: "16px",
    fontSize: "12px",
    lineHeight: "1.33",
    color: "#2e2f32",
    border: BORDERS.BLUE_GREY,
  },
  overviewBodyRowRightEdit: {
    textAlign: "right",
    paddingBottom: "8px",
    paddingLeft: "16px",
    paddingRight: "16px",
    fontSize: "12px",
    lineHeight: "1.33",
    color: "#2e2f32",
    border: BORDERS.BLUE_GREY,
  },
  paddingRight8: {
    paddingRight: "8px",
  },
  paddingLeft8: {
    paddingLeft: "8px",
  },
  unsaveSection: {
    padding: "26px 48px 26px 24px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    backgroundColor: "#002d58",
    position: 'sticky',
    top: 0,
    zIndex: 9999
  },
  unsaveText: {
    color: "#ffffff",
    margin: "0",
    fontSize: "20px",
    lineHeight: "1.4",
  },
  discardButtons: {
    marginRight: "16px",
  },
  addPhase: {
    padding: SPACING.s16,
    backgroundColor: "#f8f8f8",
  },
  addNewText: {
    color: "#000000",
    fontSize: "12px",
    lineHeight: 1.33,
    paddingLeft: "10px",
  },
  cursorPointer: {
    cursor: "pointer",
  },
  timePeriodSpacingTop: {
    marginTop: "18px",
    marginLeft:"32px"
  },
  textAlignCenter: {
    textAlign: "center"
  },
  loaderPosition: {
    top: '10px',
    position: 'relative'
  },
  divBorder: {
    border: "2px",
    borderRadius: "8px"
  },
  budgetTypePhase: {
    paddingTop: SPACING.s16,
  },
  contetSpacing8: {
    marginTop: SPACING.s8
  },
  autoApprovalSwitchLabel: {
    fontSize: "14px",
    fontFamily:"bogle",
    fontWeight:"700"
  },
  autoApprovalContainer:{
    backgroundColor: "#fff",
    borderRadius: "8px",
    padding: " 0px 8px 8px 18px",
    marginTop:"-8px"
  },
  budgetDetailsHeading: {
    fontSize: "20px",
    marginTop: "12px",
    marginLeft: "12px"
  },
  metadataColumn: {
    backgroundColor: "#fff",
    borderRadius: "8px",
    padding: "16px",
    marginLeft: "8px",
    height: "fit-content"
  },
  metadataContent: {
    display: "flex",
    flexDirection: "column",
    gap: "16px"
  },
  metadataItem: {
    display: "flex",
    flexDirection: "column",
    gap: "4px"
  },
  metadataValue: {
    fontSize: "14px",
    lineHeight: "1.43",
    color: "#2e2f32",
    wordBreak: "break-word"
  },
  metadataLink: {
    color: "#0071ce",
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline"
    },
    "&:visited": {
      color: "#0071ce"
    }
  },
  sectionHeading: {
    fontSize: "20px",
    marginTop: "24px",
    marginBottom: "16px",
    marginLeft: "0px"
  },
  marginVertical: {
    margin: "24px 0"
  },
  customHr: {
    border: "none",
    height: "1px",
    backgroundColor: "#e0e0e0",
    margin: "24px 0"
  }
});
